import script from "./LandingPageOtoAcademy.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPageOtoAcademy.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPageOtoAcademy.vue?vue&type=style&index=0&id=e0edc33c&lang=scss"

const __exports__ = script;

export default __exports__